import {useThemeSelector} from '@ui/themes/theme-selector-context';

export function useIsDarkMode(): boolean {
  const themeSelector = useThemeSelector();
  return themeSelector?.selectedTheme?.is_dark ?? false;
}
